import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const createUrl = (path: string, params?: Record<string, string | number>, removeQuestionMark = false) => {
  if (!params) return path;

  return `${path}${removeQuestionMark ? "&" : "?"}${Object.keys(params)
    .map((key) => `${key}=${encodeURI(String(params[key]))}`)
    .join("&")}`;
};

export const randomString = ({
  length,
  withSymbols = false,
  withNumbers = true,
}: {
  length: number;
  withSymbols?: boolean;
  withNumbers?: boolean;
}) => {
  let result = "";
  const specials = "!@#$%^&*";
  const numbers = "0123456789";
  const smallChars = "abcdefghijklmnopqrstuvwxyz";
  const bigChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  for (let i = 0; i < length / 4; i++) {
    if (withSymbols) {
      result += specials.charAt(Math.floor(Math.random() * specials.length));
    }
    if (withNumbers) {
      result += numbers.charAt(Math.floor(Math.random() * numbers.length));
    }
    result += smallChars.charAt(Math.floor(Math.random() * smallChars.length));
    result += bigChars.charAt(Math.floor(Math.random() * bigChars.length));
  }
  return result;
};
